
















import { Component, Prop, Emit, Vue } from "vue-property-decorator";

import SimpleMessageDialog from "@/components/common/SimpleMessageDialog.vue";

@Component({
  components: {
    SimpleMessageDialog
  }
})
export default class RefreshDialog extends Vue {
  @Prop({ required: true })
  displayRefreshDialog!: boolean;

  @Prop({ required: true })
  isForClient!: boolean;

  @Prop()
  userName!: string;

  get refreshDialogTitle() {
    return this.isForClient
      ? "Report video/sound issue"
      : "Video/sound issue reported";
  }

  get refreshDialogText() {
    return this.isForClient
      ? "We will attempt to refresh the page, if the error persist for the second time, it will be reported to your sales representative."
      : `A video or sound issue was reported by ${this.userName}, please contact them through phone, email or other channels of communication. Please contact an administrator if error persist.`;
  }

  @Emit()
  hidePrompt() {
    return;
  }

  @Emit()
  submit() {
    return;
  }
}
